/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useContext, ChangeEvent, FormEvent } from 'react';
import AlertContext from '../../contexts/alerts/alertContext';
import { HttpClient } from '../../utils/HttpClient';
import StyledLogin from './styles';

/**
 * Generates the Reset Password view
 * We need to pass the react Router and Redirect instances.
 * @param Route Route from react-router-dom
 * @param Link Link from react-router-dom
 */
const generateResetPasswordComponent = (Route: any, Link: any) => ({
    history,
}: {
    history: string[];
}): React.ReactElement => {
    // Get initial values from context
    const alertContext = useContext(AlertContext);
    const { alert, showAlert } = alertContext;

    const isAlertMessage = alert && alert.mssg;

    // Initial state
    const [email, saveEmail] = useState('');

    const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
        saveEmail(e.target.value);
    };

    // When user submits form
    const onSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
        e.preventDefault();
        try {
            await HttpClient.post('/users/reset-password', { email });
            showAlert('Password reset requested! Check your email for further instructions', 'success');
            history.push('/login');
        } catch (error) {
            showAlert(error.response?.data?.error?.reason || 'Error communicating with the API', 'error');
        }
    };

    return (
        <Route>
            <StyledLogin>
                <div className="container">
                    <div className="row">
                        <div className="col-4">
                            <div className="row title-row">
                                <div className="col-2">
                                    <img
                                        alt=""
                                        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNyIgaGVpZ2h0PSIzMiI+PGcgZmlsbD0iIzFGMjkzMyIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMjUuOTYxIDcuNTI4Yy0uMjAyIDAtLjQxMS4wNTctLjYzMS4xNzRMMTMuNTM0IDE1LjAyIDIuODcyIDguNTU0bDEwLjY3My02LjQ3MS4zNDguMjAzYS42LjYgMCAwMS4wOTcuMDQ3bDQuMjA4IDIuNDc0Yy40Mi4yMzIuNzQ5LjI0MiAxLjA2OS4wNDhsLjY5Ny0uNDA1Yy4xNy0uMTAzLjI3Mi0uMjQ4LjI4NC0uNDA3LjAxMS0uMTM5LS4wNDktLjI3NC0uMTgzLS4zOTRsLjAwMi0uMDA0YS43NzkuNzc5IDAgMDAtLjEwOC0uMDc4TDE1Ljk5NiAxLjI1bC0uMDAxLjAwMkwxNC4xLjE0Yy0uMjY0LS4xNTUtLjY4Ny0uMTg0LTEuMDA3LS4wNzNhLjk4OC45ODggMCAwMC0uMTg2LjA4NUw2LjY2MiAzLjk2M2wuMDAzLjAwNUwuODcgNy40ODVjLS40MTcuMjc1LS42NTEuNjQtLjY2IDEuMDMtLjAwOS4zNjIuMTg5LjcwOC41NjMuOThsMTIuMTU3IDcuNDIzYy4zMi4xOTUuODY4LjE5NCAxLjE5LS4wMDJsMTAuOTkyLTYuNzYydjEyLjc1MmwtMTEuNjA2IDcuMDM2TDEuOSAyMi45MDZsLS4wMDItLjQ1M2EuNzMzLjczMyAwIDAxLS4wMS0uMTE2di0zLjg5NGMwLS4zODgtLjE4NC0uNzIxLS40ODgtLjg4OGEuOTQyLjk0MiAwIDAwLS4xMDctLjA3N2wtLjU2OC0uMzQ0YS43MjYuNzI2IDAgMDAtLjEyOS0uMDYxYy0uMjgxLS4xLS41MzQuMDUxLS41OTMuMzUxTDAgMTcuNDRsLjAwMiA2LjAzYy4wNTguMzY4LjI5Ny43NDYuNTgyLjkybDEyLjMxNSA3LjQ2Yy4xNi4wOTcuMzcxLjE1MS41OTQuMTUxLjIyNCAwIC40MzUtLjA1NC41OTctLjE1MmwxMi4zMTMtNy40ODVjLjMzMy0uMjAzLjU5NC0uNjc3LjU5NC0xLjA3OUwyNyA4LjY0NmMwLS41NDktLjM4OS0xLjExOC0xLjAzOS0xLjExOCIvPjxwYXRoIGQ9Ik0xMS45NDQgMjMuODY3TDkuMzIgMjIuMzIyYy0uMjc1LS4xNi0uNTQ4LjAxNS0uNTQ4LjMzN3YxLjA2YzAgLjI3OS4xOC42MDQuNDEyLjc0MWwyLjYyNiAxLjU1OGEuNDIxLjQyMSAwIDAwLjIxNy4wNjUuMzAyLjMwMiAwIDAwLjI0Ni0uMTIuNDUzLjQ1MyAwIDAwLjA4NC0uMjh2LTEuMDc3YzAtLjI3OS0uMTgyLS42MDQtLjQxMy0uNzRtLjQxMy0zLjE5MWMwLS4yNzgtLjE4My0uNjAzLS40MTUtLjczOWwtNC4xNzgtMi40M2MtLjI3NS0uMTYtLjU0OS4wMTYtLjU0OS4zMzh2MS4wNjJjMCAuMjc5LjE4Mi42MDMuNDE1LjczOGw0LjE3OSAyLjQzYS40MjkuNDI5IDAgMDAuMjE1LjA2NS4zMDYuMzA2IDAgMDAuMjQ3LS4xMjIuNDUzLjQ1MyAwIDAwLjA4Ni0uMjh2LTEuMDYyIi8+PC9nPjwvc3ZnPg=="
                                    />
                                </div>
                                <div className="col-10">
                                    <div className="float-links float-right">
                                        <span>Don&apos;t have an account?</span>
                                        <Link to="/register" className="btn btn-sm btn-primary">
                                            Sign up
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="container-form">
                                    <h1>Reset your password</h1>
                                    {isAlertMessage ? (
                                        <div data-testid="alert" className={`alert alert-${alert.category}`}>
                                            {alert.mssg}
                                        </div>
                                    ) : null}

                                    <form onSubmit={onSubmit}>
                                        <div className="form-row">
                                            <div className="form-group col-md-12">
                                                <label htmlFor="inputEmail4">
                                                    Enter your email and we will send you a link to reset your password.
                                                </label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    id="email"
                                                    name="email"
                                                    placeholder="Email"
                                                    value={email}
                                                    onChange={onChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="form-field">
                                            <input
                                                data-testid="submit"
                                                type="submit"
                                                className="btn btn-primary btn-block"
                                                value="Send reset request"
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col offset-1">
                            <div className="wallpaper" />
                        </div>
                    </div>
                </div>
            </StyledLogin>
        </Route>
    );
};

export default generateResetPasswordComponent;
